import React from 'react';
import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { UserManualLink } from '../../../../components/dialog/userManualDialog/UserManualLink';
import { userManualDialogChapters } from '../../../../state/dialogs/chapters';

export const OperationalCostPanelHeader: React.FC = () => {
  return (
    <div
      data-testid={'dashboard-operational-costs-panel-header'}
      className="display-flex align-items-center"
    >
      <CustomFormattedMessage id="dashboard.panels.operationalCosts.header" />
      <div
        data-testid="dashboard-operational-cost-panel-information-icon-wrapper"
        className="margin-left-5"
      >
        <UserManualLink
          chapter={userManualDialogChapters.dashboardDashboardFunctions}
          dataTestId="user-manual-link-operational-costs"
        />
      </div>
    </div>
  );
};
